import { render, staticRenderFns } from "./ScaleGraph.vue?vue&type=template&id=4ec38958"
import script from "./ScaleGraph.vue?vue&type=script&lang=ts"
export * from "./ScaleGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports